import { ScreenProfileEmail } from '@dms/screen'

export default ScreenProfileEmail
